// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2wo1y","text":"SelectPayment_text__2xoG6","title":"SelectPayment_title__2cXWx","btn":"SelectPayment_btn__WWn0s"};